jQuery(document).ready(function (jQuery) {
    var heroContent = jQuery(".hero-content-wrapper")
    var heroRow = jQuery(".hero-content")
    var mainContent = jQuery(".main-content")
    heroContent.addClass("hero-load")
    heroRow.addClass("hero-load")
    mainContent.addClass("content-load")
});

function popIn() {
    var pageTop = jQuery(document).scrollTop()
    var pageBottom = pageTop + jQuery(window).height()
    var tags = jQuery(".row-secondary")

    for (var i = 0; i < tags.length; i++) {
        var tag = tags[i]

        if (jQuery(tag).position().top < pageBottom) {
            jQuery(tag).addClass("visible")
        } else {
            jQuery(tag).removeClass("visible")
        }
    }
}

jQuery(document).on("scroll", popIn);

//NAV
window.addEventListener('DOMContentLoaded', function () {
    var mobileNavShowing = false;

    jQuery('.mobile-menu-trigger').on('click', function (e) {
        if (!mobileNavShowing) {
            mobileNavShowing = true;
            jQuery('.mobile-nav.mobile-only').toggleClass('mobile-open');
            jQuery('.mobile-menu-trigger').toggleClass('menu-active');
            jQuery('.mobile-overlay').toggleClass('active');
            jQuery('.mobile-menu-bar-1').css({
                marginTop: '4px',
                transform: 'rotate(45deg)',
                boxShadow: 'none',
            });
            jQuery('.mobile-menu-bar-2').css({
                marginTop: '-2px',
                transform: 'rotate(-45deg)',
                boxShadow: 'none',
            });
            jQuery('body').css({
                overflow: 'hidden'
            });
        } else {
            mobileNavShowing = false;
            jQuery('body').css({
                overflow: 'initial'
            });
            jQuery('.mobile-nav.mobile-only').toggleClass('mobile-open');
            jQuery('.mobile-menu-trigger').toggleClass('menu-active');
            jQuery('.mobile-overlay').toggleClass('active');
            jQuery('.mobile-menu-bar-1').css({
                marginTop: '0px',
                transform: 'rotate(0deg)',
            });
            jQuery('.mobile-menu-bar-2').css({
                marginTop: '5px',
                transform: 'rotate(0deg)',
            });
        }
    });

    jQuery('.mobile-overlay').on('click', function (e) {

        mobileNavShowing = false;
        jQuery('body').css({
            overflow: 'initial'
        });
        jQuery('.mobile-nav.mobile-only').toggleClass('mobile-open');
        jQuery('.mobile-menu-trigger').toggleClass('menu-active');
        jQuery('.mobile-overlay').toggleClass('active');
        jQuery('.mobile-menu-bar-1').css({
            marginTop: '0px',
            transform: 'rotate(0deg)',
        });
        jQuery('.mobile-menu-bar-2').css({
            marginTop: '5px',
            transform: 'rotate(0deg)',
        });
    });
});